import { ItemSkeletonComponent } from './item-skeleton.component';

export default angular
  .module('sfMobile.components.item-skeleton', [
    'sfMobile.components.text-skeleton',
  ])
  .component('sfItemSkeleton', ItemSkeletonComponent).name;
